var render = function render(_c,_vm){return _c('span',{staticClass:"ax-generation-failed text-danger"},[_vm._v(" generation error ")])
}
var staticRenderFns = []

export { render, staticRenderFns }